/* eslint-disable */
// @ts-nocheck

import {renderToCanvas} from '../../../lib/truvu';

/**
 * TruVu-based printIndex function
 * Renders frames from JPEG blob URLs (primary) or RGB data (fallback) to canvas
 * Optimized for memory efficiency on older devices
 */
export async function printIndex(
  frames: any[],
  frameIndex: number,
  canvas: HTMLCanvasElement
) {
  try {
    console.log(`[printIndex] frame ${frameIndex} of ${frames.length}`);

    // Handle bounds checking
    if (
      !frames ||
      frames.length === 0 ||
      frameIndex < 0 ||
      frameIndex >= frames.length
    ) {
      console.warn('printIndex: Invalid frame index or empty frames array');
      return;
    }

    // Access frame directly by array index (now properly mapped)
    const frameData = frames[frameIndex];

    // TruVu frames have different structure than LibAV frames
    if (!frameData || !frameData.frame) {
      console.warn('printIndex: Invalid frame data at index', frameIndex);
      return;
    }

    const frame = frameData.frame;

    // Check if frame has blob URL (new JPEG approach) or RGB data (fallback)
    if (!frame.blobUrl && !frame.rgbData) {
      console.warn(
        'printIndex: Frame has neither blobUrl nor rgbData at index',
        frameIndex
      );
      return;
    }

    // Use TruVu's renderToCanvas function (handles both blob URLs and RGB data)
    await renderToCanvas(frame, canvas);

    // Optional: Add debug info to understand frame sequencing
    if (frameData.globalFrameIndex !== undefined) {
      const frameType = frame.blobUrl ? 'JPEG blob' : 'RGB data';
      console.log(
        `[printIndex] Rendered ${frameType} global frame ${frameData.globalFrameIndex} at array index ${frameIndex}`
      );
    }
  } catch (error) {
    console.error('printIndex error:', error);
    // Gracefully handle errors without breaking the UI
  }
}
